import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CourseCompleteCrownIcon } from '@lean-body/components/atoms';
import { CourseVolumeInfo, CourseVolumeProgress } from '@lean-body/components/molecules';
import { MediaBreakPointUp, Colors } from '@lean-body/components/styles';
import { AiIcon } from '../atoms/icons/ai_icon';
export const CourseVolumeItem = ({ volume, latestVolume, classObject, onClickVolume, isNotGenerated, }) => {
    return (React.createElement("div", { className: css(styles.container, isNotGenerated && styles.volumeNotGenerated, classObject), onClick: () => onClickVolume && onClickVolume(volume.id) },
        isNotGenerated ? (React.createElement(CourseVolumeInfo, { classObject: styles.volumeInfo, volumeNumber: latestVolume.nextVolumeNumber(), isNotGenerated: true })) : (React.createElement(CourseVolumeInfo, { classObject: styles.volumeInfo, volumeNumber: volume.volumeNumber, totalLessons: volume.totalDays })),
        React.createElement("div", null, isNotGenerated ? (React.createElement(AiIcon, { classObject: styles.aiIcon })) : volume.isCompleted ? (React.createElement(CourseCompleteCrownIcon, null)) : (React.createElement(CourseVolumeProgress, { totalLessons: volume.totalDays, completedLessons: volume.finishedDays })))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: `1px solid ${Colors.BorderLightGray}`,
        borderRadius: 10,
        padding: '17.5px 16px',
        [MediaBreakPointUp.MD]: {
            padding: '17.5px 50px',
        },
    },
    volumeNotGenerated: {
        padding: '20px 16px',
        [MediaBreakPointUp.MD]: {
            padding: '20px 50px',
        },
    },
    volumeInfo: {
        marginRight: 20,
    },
    aiIcon: {
        width: 40,
        height: 40,
    },
});
